export default __webpack_public_path__ + "static/media/ic_assignment.e3da2e9f.svg";